import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext, useMemo } from 'react';
import createClassNames from './createClassNames';
var defaultThemeContext = {
  prefixes: {},
  classNameMap: {},
  createClassNameMapper: function createClassNameMapper(classMap) {
    return createClassNames(classMap, {}, function (item) {
      return item;
    });
  }
};
var ThemeContext = /*#__PURE__*/React.createContext(defaultThemeContext);
var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;

function ThemeProvider(_ref) {
  var prefixes = _ref.prefixes,
      classNameMap = _ref.classNameMap,
      classNameConverter = _ref.classNameConverter,
      children = _ref.children;
  var copiedPrefixes = useMemo(function () {
    return _extends({}, prefixes);
  }, [prefixes]);
  var globalClassNameMap = useMemo(function () {
    return _extends({}, classNameMap);
  }, [classNameMap]);

  var createClassNameMapper = function createClassNameMapper(localClassNameMap) {
    return createClassNames(localClassNameMap, globalClassNameMap, classNameConverter);
  };

  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      prefixes: copiedPrefixes,
      classNameMap: globalClassNameMap,
      createClassNameMapper: createClassNameMapper
    }
  }, children);
}

export function useBootstrapPrefix(prefix, defaultPrefix) {
  var _useContext = useContext(ThemeContext),
      prefixes = _useContext.prefixes;

  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
export function useClassNameMapper(localClassNameMap) {
  if (localClassNameMap === void 0) {
    localClassNameMap = {};
  }

  var _useContext2 = useContext(ThemeContext),
      createClassNameMapper = _useContext2.createClassNameMapper;

  return createClassNameMapper(localClassNameMap);
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  var Wrapped = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var props = _extends({}, _ref2);

    props[forwardRefAs] = ref;
    var bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      bsPrefix: bsPrefix
    }));
  });
  Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
  return Wrapped;
}

export { createBootstrapComponent, Consumer as ThemeConsumer };
export default ThemeProvider;